import { RootState } from '@/store/types'
import { Module } from 'vuex'
import { MinutasPronosticoState } from './types'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const state: MinutasPronosticoState = {
  minutasPronostico: [],
  link_descarga: '',
  isLoaded: false,
  error: { state: false }
}

const namespaced: boolean = true

export const minutasPronostico: Module<MinutasPronosticoState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
